import MirsTable from "components/general/table/Table";
import Competitors from "components/presentation/Competitor"

import { findArray } from 'helpers/utils'
import Label from "components/general/Label"

const TriRaceInfo = ({ config }) => {


    let splitSw = findArray(config.extendedConfig, { code: ['SWIM'], type: ['COURSE'] })
    let distanceSwim = splitSw?.value
    let numberLapsSw = findArray(splitSw?.extension, { code: ['LAPS'] })?.value

    let splitBk = findArray(config.extendedConfig, { code: ['BIKE'], type: ['COURSE'] })
    let distanceBike = splitBk?.value
    let numberLapsBk = findArray(splitBk?.extension, { code: ['LAPS'] })?.value

    let splitRn = findArray(config.extendedConfig, { code: ['RUN'], type: ['COURSE'] })
    let distanceRun = splitRn?.value
    let numberLapsRn = findArray(splitRn?.extension, { code: ['LAPS'] })?.value

    return (
        <>
            <div>
                <b><Label data="HeaderSWIM" />:</b> {distanceSwim}m (Laps: {numberLapsSw}), <b><Label data="HeaderBIKE" />:</b> {distanceBike}Km (Laps: {numberLapsBk}), <b><Label data="HeaderRUN" />:</b> {distanceRun}Km (Laps: {numberLapsRn})
            </div>


        </>
    )



};
export default TriRaceInfo;